import { useNavigation } from '@react-navigation/native';
import { BaseText, theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import { PermitElementRow } from 'components/services/PermitElementRow';
import useGetLoyaltyPermitFreeTimes from 'hooks/useGetLoyaltyPermitFreeTimes.ts';
import { t } from 'i18next';
import React from 'react';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import { formatPermitValid } from 'utils/permitUtils';
import { PermitContentWrapper } from '../styles';

const LoyaltyPermitTicketContent = ({
  permit,
  showDetailsButton = false,
}: {
  permit: UnifiedPermit;
  showDetailsButton: boolean;
}) => {
  const { navigate } = useNavigation<RootNavProps>();

  const freeTimes = useGetLoyaltyPermitFreeTimes(permit);
  const registeredVehiclesWithFreeTime =
    freeTimes?.registeredVehiclesWithFreeTime;

  const isFreeTimeAvailable = (freeTime: string) => freeTime !== null;

  const isFreeTimeLeftToday = (freeTime: string) => freeTime !== '';

  return (
    <PermitContentWrapper>
      {registeredVehiclesWithFreeTime?.length !== null &&
        registeredVehiclesWithFreeTime?.length > 0 &&
        registeredVehiclesWithFreeTime
          .filter((vehicleWithFreeTime: any) =>
            isFreeTimeAvailable(vehicleWithFreeTime?.freeTime)
          )
          .map((vehicleWithFreeTime: any) => {
            return (
              <MenuItem
                menuLabel={`${
                  vehicleWithFreeTime?.licensePlate?.name ||
                  vehicleWithFreeTime?.licensePlate.plateText
                } • ${t('permit.loyalty.freeTimeLeftToday')}`}
                key={vehicleWithFreeTime?.licensePlate?.plateText}
                rightComponent={
                  isFreeTimeLeftToday(vehicleWithFreeTime?.freeTime) ? (
                    <BaseText>{vehicleWithFreeTime?.freeTime}</BaseText>
                  ) : (
                    <BaseText color={theme.colors.gray300}>
                      {t('permit.loyalty.noTimeLeftToday')}
                    </BaseText>
                  )
                }
                color={theme.colors.gray300}
              />
            );
          })}
      {permit?.validity?.validFrom && (
        <PermitElementRow
          label={t('permit.loyalty.validFrom')}
          detail={formatPermitValid(permit?.validity?.validFrom)}
        />
      )}
      {showDetailsButton && (
        <MenuItem
          menuLabel={t('permit.loyalty.viewDetails')}
          withArrow={true}
          noBorder={true}
          onPress={() => {
            navigate('permit', { permitId: permit?.id });
          }}
        />
      )}
    </PermitContentWrapper>
  );
};

export default LoyaltyPermitTicketContent;
